import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReconciled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 4.125,
			width: 10.375,
			height: 10.375,
			rx: 2.5,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 1C13.657 1 15 2.343 15 4V9.375C15 10.912 13.844 12.175 12.354 12.351C12.367 12.236 12.375 12.119 12.375 12V11.338C13.3 11.162 14 10.351 14 9.375V4C14 2.895 13.105 2 12 2H6.625C5.649 2 4.838 2.7 4.662 3.625H4C3.88 3.625 3.762 3.632 3.646 3.646C3.821 2.156 5.088 1 6.625 1H12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.063 9.429L5.696 11.063L9.196 7.563",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgReconciled;
